import type {NavSectionProps} from 'src/components/nav-section';

import {paths} from 'src/routes/paths';

import {CONFIG} from 'src/global-config';

import {Label} from 'src/components/label';
import {SvgColor} from 'src/components/svg-color';

// ----------------------------------------------------------------------

const icon = (name: string) => (
  <SvgColor src={`${CONFIG.assetsDir}/assets/icons/navbar/${name}.svg`}/>
);

const ICONS = {
  job: icon('ic-job'),
  blog: icon('ic-blog'),
  chat: icon('ic-chat'),
  mail: icon('ic-mail'),
  user: icon('ic-user'),
  file: icon('ic-file'),
  lock: icon('ic-lock'),
  tour: icon('ic-tour'),
  order: icon('ic-order'),
  label: icon('ic-label'),
  blank: icon('ic-blank'),
  kanban: icon('ic-kanban'),
  folder: icon('ic-folder'),
  course: icon('ic-course'),
  banking: icon('ic-banking'),
  booking: icon('ic-booking'),
  invoice: icon('ic-invoice'),
  product: icon('ic-product'),
  calendar: icon('ic-calendar'),
  disabled: icon('ic-disabled'),
  external: icon('ic-external'),
  menuItem: icon('ic-menu-item'),
  ecommerce: icon('ic-ecommerce'),
  analytics: icon('ic-analytics'),
  dashboard: icon('ic-dashboard'),
  parameter: icon('ic-parameter'),
  queue: icon('ic-queue'),
};

// ----------------------------------------------------------------------

export const navData: NavSectionProps['data'] = [
  /**
   * Overview
   */
  {
    subheader: 'Anwendungen',
    items: [
      {
        title: 'Etikettenentfernung',
        path: paths.apps.etikettenentfernung.root,
        icon: ICONS.parameter,
        info: <Label>v{CONFIG.appVersion}</Label>,
        children: [
          {title: 'Live', path: paths.apps.etikettenentfernung.live},
          {title: 'Tabelle', path: paths.apps.etikettenentfernung.list},
          { title: 'Reinigungsbilder', path: paths.apps.etikettenentfernung.cleaningImages },
        ]
      },
      {
        title: 'Rebo Pipeline',
        path: paths.apps.reboPipeline.root,
        icon: ICONS.parameter,
        children: [
          { title: 'Live', path: paths.apps.reboPipeline.live },
          { title: 'Tabelle', path: paths.apps.reboPipeline.list },
        ],
      },
      {
        title: 'Schwerte Uploads (RFS)',
        path: paths.apps.webUploads.root,
        icon: ICONS.file,
      },
    ],
  },
  /**
   * Management
   */
  {
    subheader: 'Management',
    items: [
      {
        title: 'Label Events',
        path: paths.dashboard.labelEvents,
        icon: ICONS.queue,
      },
      {
        title: 'Wiege Events',
        path: paths.dashboard.weightEvents,
        icon: ICONS.queue,
      },
      {
        title: 'Storage',
        path: paths.dashboard.storage,
        icon: ICONS.file,
      },
    ],
  },
  {
    subheader: 'Operations',
    items: [
      {
        title: 'Abrechnung',
        path: paths.dashboard.billing.root,
        icon: ICONS.invoice,
        roles: ['admin', 'operator']
      }
    ]
  },
  {
    subheader: 'Analysen',
    items: [
      {
        title: 'RDB Restmenge Dashboard',
        path: paths.dashboard.analytics.waage,
        icon: ICONS.analytics,
      },
      {
        title: 'MBG Events Übersicht',
        path: paths.dashboard.analytics.mbg_events,
        icon: ICONS.analytics,
      },
    ]
  },
  {
    subheader: 'Administration',
    items: [
      {
        title: 'Benutzer',
        path: paths.dashboard.users,
        icon: ICONS.user,
        roles: ['admin'],
      },
      {
        title: 'Einstellungen',
        path: paths.dashboard.settings.root,
        icon: ICONS.parameter,
        roles: ['admin', 'operator'],
      },
    ]
  },
];
